module.exports = __webpack_public_path__ + "img/conversation.8159cc1e.svg";